import * as React from 'react'

function SvgDiscoverIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 34 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width={34} height={24} rx={2.4} fill="#FFA200" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.715 11.893h-.264V10.5h.264c.58 0 .845.258.845.67 0 .465-.264.723-.845.723zm1.795-.774c0-.877-.58-1.341-1.636-1.341h-1.32v4.59h.897v-1.856h.106l1.214 1.856h1.108l-1.425-1.908a1.258 1.258 0 001.056-1.341zm-6.07 3.25h2.533v-.774h-1.636v-1.238h1.584v-.774h-1.584v-1.031h1.636v-.774H25.44v4.59zm-2.639-1.496l-1.213-3.095h-.95l1.952 4.694h.475l1.953-4.694h-.95l-1.267 3.095zm-10.713-.774a2.382 2.382 0 002.375 2.373c.422 0 .792-.104 1.161-.258v-1.032c-.264.31-.633.516-1.055.516-.845 0-1.53-.619-1.53-1.444v-.103c-.054-.826.632-1.548 1.477-1.6.422 0 .844.207 1.108.517v-1.032c-.317-.206-.739-.258-1.108-.258-1.372-.103-2.428.98-2.428 2.321zm-1.636-.567c-.528-.207-.686-.31-.686-.568.053-.31.317-.567.633-.515.264 0 .528.154.74.36l.474-.618c-.37-.31-.844-.516-1.32-.516a1.342 1.342 0 00-1.424 1.238v.051c0 .62.264.98 1.108 1.238.211.052.422.155.633.258a.54.54 0 01.264.464c0 .361-.316.67-.633.67h-.053c-.422 0-.791-.257-.95-.618l-.58.567c.316.568.95.877 1.583.877a1.476 1.476 0 001.583-1.393v-.154c-.052-.62-.316-.929-1.372-1.341zm-3.061 2.836h.897v-4.59H7.39v4.59zm-1.795-1.134a1.698 1.698 0 01-1.213.36h-.264v-3.042h.264c.422-.052.897.103 1.213.36.317.31.475.723.475 1.135 0 .465-.158.877-.475 1.187zM4.541 9.778h-1.32v4.59h1.32c.58.052 1.161-.154 1.636-.515.528-.465.845-1.083.845-1.754.052-1.238-.95-2.27-2.217-2.321H4.54zm13.774-.106c-1.319 0-2.427 1.031-2.427 2.372 0 1.29 1.055 2.373 2.428 2.424 1.372.052 2.427-1.031 2.48-2.372-.053-1.341-1.108-2.424-2.48-2.424z"
        fill="#fff"
      />
    </svg>
  )
}

export default SvgDiscoverIcon
